import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { BcacButtonComponent } from './bcac-button.component';



@NgModule({
  declarations: [BcacButtonComponent],
  imports: [
    CommonModule,
    NgZorroAntdModule
  ], exports: [
    BcacButtonComponent
  ]
})
export class BcacButtonModule { }
